import React from 'react';
import Default from '../../../images/icon/default.png';
const DefaultPlayer = ({disabled = false}) => {
    return(
        <span className={"device_icon"} style={{opacity: disabled ? 0.7 : 1, webkitFilter: disabled ? 'grayscale(100%)' : undefined}}>
            <img src={Default} data-deviceType={'DefaultPlayer'}/>
        </span>
    )
}
export default DefaultPlayer